import Link from "next/link";
import type { ReactNode } from "react";
import { formatNumber, cn } from "@/lib/utils";

interface StatItemProps {
  value: number;
  label: string;
  showDot?: boolean;
  className?: string;
  /** Makes the stat clickable (e.g. dashboard → catalogue) */
  href?: string;
}

export function StatItem({
  value,
  label,
  showDot = false,
  className = "",
  href,
}: StatItemProps) {
  const content = (
    <>
      <span className="font-display text-3xl text-secondary">
        {formatNumber(value)}
      </span>
      <span className="mt-1 flex items-center gap-1.5 text-[10px] font-medium uppercase tracking-wider text-muted">
        {label}
        {showDot ? (
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-primary" />
        ) : null}
      </span>
    </>
  );

  const classes = cn(
    "flex flex-col",
    href && "rounded-lg transition hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40",
    className,
  );

  if (href) {
    return (
      <Link href={href} className={classes}>
        {content}
      </Link>
    );
  }

  return <div className={classes}>{content as ReactNode}</div>;
}
